import gql from 'graphql-tag'
import client from '@stores/apollo'

export default {
  bookings: ({
    bookingIds,
    subject,
    content,
    signature,
  }: {
    bookingIds: string[]
    subject?: string
    content?: string
    signature?: string
  }) => {
    return client.gql.mutate({
      mutation: cancelMutation,
      variables: { input: { bookingIds, subject, content, signature } },
    })
  },
  schedule: (id: string) => {
    return client.gql.mutate({
      mutation: cancelScheduleMutation,
      variables: { input: { id } },
    })
  },
}

const cancelScheduleMutation = gql`
  mutation cancelBookingsSchduleMutation($input: DeleteBookingScheduleInput!) {
    deleteBookingSchedule(input: $input) {
      bookingSchedule {
        id
      }
    }
  }
`

const cancelMutation = gql`
  mutation cancelBookingsMutation($input: CancelBookingInput!) {
    cancelBooking(input: $input) {
      clientMutationId
    }
  }
`
